export const SIZEINPUT_CHANGED_VALUE = 'SIZEINPUT_CHANGED_VALUE';
export const SIZEINPUT_CLEAR_DATA = 'SIZEINPUT_CLEAR_DATA';
export const SIZEINPUT_SETDEFAULT_DATA = 'SIZEINPUT_SETDEFAULT_DATA';

export const clearSizeInputData = () => ({
    type: SIZEINPUT_CLEAR_DATA,
})

export const setDefaultData = data => ({
    type: SIZEINPUT_SETDEFAULT_DATA,
    payload: {
        defaultData: data
    }
})

export const updateData = data => ({
    type: SIZEINPUT_CHANGED_VALUE,
    payload: {
        data: data
    }
})